export default {
  'posList.name': 'Points of sale',
};
